import Model, { attr, belongsTo, hasMany } from '@ember-data/model';
import { cached } from '@glimmer/tracking';
import {
  type InvitationRole,
  type InvitationSubrole,
} from 'uplisting-frontend/models/invitation';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class TeammateModel extends Model {
  @attr('string') userId?: string;

  @attr('string') name!: string;
  @attr('string') email!: string;
  @attr('string') role!: InvitationRole;
  @attr('string') subrole!: InvitationSubrole | null;
  @attr('date') createdAt!: Date;
  @attr('string') phoneNumber?: string;

  @belongsTo('client', { inverse: 'teammates', async: false })
  client?: ModelRegistry['client'];

  @hasMany('property', { async: false, inverse: null })
  properties!: ModelRegistry['property'][];

  @hasMany('multi-unit', { async: false, inverse: null })
  multiUnits!: ModelRegistry['multi-unit'][];

  @hasMany('permission', { inverse: 'teammate', async: false })
  permissions!: ModelRegistry['permission'][];

  @cached
  get hasClient(): boolean {
    return !!this.client?.id;
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    teammate: TeammateModel;
  }
}
